import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  TextField,
  Typography,
  Button,
  Box,
  Checkbox,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Autocomplete,
} from "@mui/material";
import ArtikelTable from "./Artikeltable";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

function NewExpense(props) {
  const { t } = useTranslation();
  //Standardfelder
  const theme = useTheme();

  const {
    changeValue,
    data,
    addExpenseModal,
    readFile,
    currencies,
    isLoading,
    settings,
    lock,
    artikelOptionen,
    neueArtikelBerechnen,
    cancelLoading,
    artikelDialog,
    setArtikelDialog,
    editModus,
    setEditModus,
    selectedTab,
    setSelectedTab,
    addArtikel,
    selectedArtikel,
    setSelectedArtikel,
    staaten,
    letzteAenderung,
    setLetzteAenderung,
    fehlerFound,
    setFehlerFound,
  } = props;
  return (
    <>
      <Backdrop
        open={isLoading}
        style={{
          color: theme.palette.common.white,
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Box p={2}>
          <Grid container justifyContent="center">
            <Hidden mdDown>
              <Grid item md={12}>
                <CircularProgress size={40} style={{ marginLeft: "40%" }} color="inherit" />
                <Typography variant="h6">{t("Beleg wird ausgelesen")}</Typography>
                <Button fullWidth variant="primary" onClick={() => cancelLoading()}>
                  Abbrechen
                </Button>
              </Grid>
            </Hidden>
            <Hidden mdUp>
              <Grid item xs={5} />
              <Grid item xs={2} md={8}>
                <CircularProgress color="inherit" />
              </Grid>
              <Grid item xs={5} />
              <Grid item xs={1} />
              {/* <Grid item xs={1}></Grid> */}
              <Grid item xs={10} md={8}>
                <Typography align="center" variant="h6">
                  {t("Beleg wird ausgelesen")}
                </Typography>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={1} />
              <Grid item xs={10} md={8}>
                <Button fullWidth variant="primary" onClick={() => cancelLoading()}>
                  Abbrechen
                </Button>
              </Grid>
              <Grid item xs={1} />
              {/* <Grid item xs={1}></Grid> */}
            </Hidden>
          </Grid>
        </Box>
      </Backdrop>
      <Grid container rowSpacing={{ md: 2, xs: 2 }} paddingBottom={0}>
        <Grid md={3} xs={0} />
        <Grid item alignItems={"center"} md={6} xs={12} paddingBottom={{ md: 3, xs: 1 }}>
          <input multiple color="primary" type="file" accept=".pdf,image/png,image/jpeg" id="file-upload" onChange={(e) => readFile(e)} style={{ display: "none" }} />
          <label htmlFor="file-upload" className="mr-2">
            <Button
              fullWidth
              disabled={addExpenseModal === "DETAILS" || lock}
              style={{ marginTop: "18px" }}
              variant="contained"
              component="span"
              color="primary"
              label={t("Dateiupload")}
            >
              {t("Beleg hochladen und auslesen")}
            </Button>
          </label>
        </Grid>
        <Grid md={3} xs={0} />
        {data?.file?.name && (
          <>
            <Grid md={3} xs={0} />
            <Grid item md={6} xs={12}>
              <Typography align="center">Ausgewählte Datei: </Typography>
              <Typography align="center">{data.file?.name}</Typography>
            </Grid>
            <Grid md={3} />
          </>
        )}
        <Grid item md={3} />
        <Grid item alignItems={"center"} xs={12} md={6} borderBottom={0}>
          {artikelOptionen ? (
            <TextField
              variant="standard"
              size="small"
              fullWidth
              label="Artikel"
              select
              disabled={lock}
              onChange={(e) => changeValue("ARTIKEL_KEY", e.target.value)}
              value={data.WERTE?.["ARTIKEL_KEY"] ? data.WERTE?.["ARTIKEL_KEY"] : ""}
            >
              {artikelOptionen?.map((artikel) => {
                return (
                  <MenuItem key={artikel.key} value={artikel.key} index={artikel.key}>
                    {artikel.bez}
                  </MenuItem>
                );
              })}
            </TextField>
          ) : (
            <>
              {settings?.betreffVorgaben !== "" && settings?.betreffVorgaben !== undefined ? (
                <TextField
                  variant="standard"
                  size="small"
                  fullWidth
                  label="Betreff"
                  select
                  onChange={(e) => changeValue("BETREFF", e.target.value)}
                  value={data.WERTE?.["BETREFF"] ? data.WERTE?.["BETREFF"] : ""}
                >
                  {settings?.betreffVorgaben?.split("\n").map((item2, index2) => {
                    var tmpkey = "";
                    var tmpval = "";
                    var tmppos = item2.indexOf(";");
                    if (tmppos >= 0) {
                      tmpkey = item2.substr(0, tmppos);
                      tmpval = item2.substr(tmppos + 1);
                    } else {
                      tmpkey = item2;
                      tmpval = item2;
                    }
                    return (
                      <MenuItem key={tmpval} value={tmpval} index={index2}>
                        {tmpval}
                      </MenuItem>
                    );
                  })}
                </TextField>
              ) : (
                <TextField
                  variant="standard"
                  size="small"
                  fullWidth
                  disabled={lock}
                  label="Betreff"
                  onChange={(e) => changeValue("BETREFF", e.target.value)}
                  value={data.WERTE?.["BETREFF"] ? data.WERTE?.["BETREFF"] : ""}
                />
              )}
            </>
          )}
          <TextField
            variant="standard"
            size="small"
            fullWidth
            label="Herkunftsland des Belegs"
            select
                        disabled={lock}
            value={data.WERTE?.SITZ ? data.WERTE?.SITZ : ""}
            onChange={(e) => changeValue("SITZ", e.target.value)}
          >
            <MenuItem key={"N"} value={"N"} index={"N"}>
              Ausland
            </MenuItem>
            <MenuItem key={"J"} value={"J"} index={"J"}>
              Deutschland
            </MenuItem>
          </TextField>
        </Grid>
        <Grid item md={3} xs={0} />

        <Grid item md={3} xs={0} />
        <Grid item alignItems={"center"} md={6} xs={12} borderBottom={0}>
          <TextField
            type="date"
            variant="standard"
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            disabled={lock}
            onChange={(e) => changeValue("DATUM", e.target.value)}
            label={"Datum"}
            value={data.WERTE?.["DATUM"] ? data.WERTE?.["DATUM"] : ""}
          />
        </Grid>
        <Grid item md={3} xs={0} />
        {data.WERTE.STEUERSATZ?.map((steuersatz, count) => {
          const steuer = parseInt(steuersatz);
          if (parseInt(data.WERTE?.["BRUTTO"][count]) === 0 || !parseInt(data.WERTE?.["BRUTTO"][count])) return;
          return (
            <>
              <Grid item md={3} xs={0} />
              <Grid item alignItems={"center"} md={6} xs={6} borderBottom={0}>
                <TextField
                  variant="standard"
                  // disabled={lock}
                  disabled
                  type="number"
                  size="small"
                  fullWidth
                  onChange={(e) => changeValue("NETTO", e.target.value)}
                  label={"Netto " + steuer + "%"}
                  value={data.WERTE?.["NETTO"][count]}
                />
              </Grid>
              <Grid item md={3} xs={0} />
              <Grid item md={3} xs={0} />
              <Grid item alignItems={"center"} md={6} xs={6} borderBottom={0}>
                <TextField
                  variant="standard"
                  // disabled={lock}
                  disabled
                  type="number"
                  size="small"
                  fullWidth
                  onChange={(e) => changeValue("STEUER", e.target.value)}
                  label={"MWST " + steuer + "%"}
                  value={data.WERTE?.["STEUER"][count]}
                />
              </Grid>
              <Grid item md={3} />
              <Grid item md={3} xs={0} />
              <Grid item alignItems={"center"} md={6} xs={12} borderBottom={0}>
                <TextField
                  variant="standard"
                  // disabled={lock}
                  disabled
                  type="number"
                  size="small"
                  fullWidth
                  onChange={(e) => changeValue("BRUTTO", e.target.value)}
                  label={"Brutto " + steuer + "%"}
                  value={data.WERTE?.["BRUTTO"][count]}
                />
              </Grid>
              <Grid item md={3} xs={0} />
            </>
          );
        })}
        <Grid item md={3} xs={0} />
        <Grid item alignItems={"center"} md={6} xs={12} borderBottom={0}>
          <TextField
            type="number"
            // disabled={lock}
            disabled
            variant="standard"
            size="small"
            fullWidth
            onChange={(e) => changeValue("GESAMT", e.target.value)}
            label={"Gesamt "}
            value={data.WERTE?.["GESAMT"] ? data.WERTE?.["GESAMT"] : ""}
          />
        </Grid>
        <Grid item md={3} xs={0} />
        <Grid item md={3} xs={0} />
        <Grid item md={3} xs={5}>
          <FormControl fullWidth>
            <InputLabel id="">Bezahlt in</InputLabel>
            <Select
              disabled={lock}
              label="Bezahlt in"
              fullWidth
              helperText=""
              value={data.WERTE?.["waehrung"]}
              onChange={(e) => changeValue("waehrung", e.target.value)}
            >
              {currencies.map((waehrung) => (
                <MenuItem value={waehrung.value}>{waehrung.label}</MenuItem>
              ))}
              <MenuItem value={"EURO"}>Euro </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={3} xs={7}>
          <FormControlLabel
            control={
              <Checkbox
                disabled={lock}
                checked={data.WERTE?.["KREDITKARTE"]}
                onChange={(event) => changeValue("KREDITKARTE", event.target.checked)}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            labelPlacement=""
            label="Über Firmenkreditkarte gezahlt"
          />
        </Grid>
        <Grid item md={3} />
        <Grid item md={3} />
        <Grid item md={6} xs={12}>
          <Button onClick={() => setArtikelDialog(true)} fullWidth disabled={lock} variant="contained" component="span" color="primary">
            {t("Artikel verwalten")}
          </Button>
        </Grid>
        <Grid item md={12} borderBottom={3} xs={12} />
        <Grid item md={1.5} xs={0} />
        <Grid item md={3} xs={12}>
          {" "}
          <TextField
            variant="standard"
            fullWidth
            disabled
            size="  "
            label={
              <Typography variant="h6">
                {"Kurs zum " +
                  data.WERTE?.["DATUM"]?.substring(8, 10) +
                  "." +
                  data.WERTE?.["DATUM"]?.substring(5, 7) +
                  "." +
                  data.WERTE?.["DATUM"]?.substring(0, 4) +
                  " *"}
              </Typography>
            }
            value={data.WERTE?.["KURS"] ? data.WERTE?.["KURS"] : ""}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <TextField
            variant="standard"
            disabled
            // disabled={addExpenseModal === "DETAILS"}
            size=""
            fullWidth
            onChange={(e) => changeValue("ERGEBNIS", e.target.value)}
            label={<Typography variant="h6">{"Ergebnis "}</Typography>}
            value={data.WERTE?.["ERGEBNIS"]}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <TextField
            variant="standard"
            disabled
            // disabled={addExpenseModal === "DETAILS"}
            size=""
            fullWidth
            onChange={(e) => changeValue("ERGEBNIS", e.target.value)}
            label={<Typography variant="h6">{"Auszahlung "}</Typography>}
            value={data.WERTE?.["AUSZAHLUNG"]}
          />
        </Grid>
        <Grid item md={1.5} />
      </Grid>
      <ArtikelTable
      settings={settings}
        belegWerte={data.WERTE}
        steuerSaetze={data.WERTE.STEUERSATZ}
        open={artikelDialog}
        onOpenChange={setArtikelDialog}
        artikel={data?.WERTE?.ARTIKEL ?? []}
        neueArtikelBerechnen={neueArtikelBerechnen}
        artikelOptionen={artikelOptionen}
        changeValue={changeValue}
        editModus={editModus}
        setEditModus={setEditModus}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        addArtikel={addArtikel}
        selectedArtikel={selectedArtikel}
        setSelectedArtikel={setSelectedArtikel}
        letzteAenderung={letzteAenderung}
        setLetzteAenderung={setLetzteAenderung}
        fehlerFound={fehlerFound}
        setFehlerFound={setFehlerFound}
      />
    </>
  );
}

export default NewExpense;
